import React from 'react';
import { Panel } from 'rsuite';
// If you want Markdown rendering, install react-markdown
import ReactMarkdown from 'react-markdown';
import PageContent from '@/components/PageContent';

const guideMarkdown = `
# 📘 Prompt Template Authoring Guide

This guide explains how to design prompt templates using the **PromptTemplateModel**. Templates are written in **Scriban syntax** and can reference assets, variables, and rendering configuration.

---

## 🔑 Core Concepts
- **Assets**: Represent input files (e.g., images).
- **Variables**: Represent dynamic values (e.g., text, numbers).
- **Rendering Config**: Defines global settings like aspect ratio and AI provider.

---

## 🧩 Model Structure

### Assets
Each asset has:
- \`exists\` → true if available
- \`type\` → e.g., "user image"

**Usage:**
\`\`\`scriban
{{ if assets.shoe.exists }}
The shoe image is provided (type: {{ assets.shoe.type }}).
{{ end }}
\`\`\`

### Variables
Each variable has:
- \`exists\` → true if value present
- \`value\` → raw value
- \`displayValue\` → formatted text

**Usage:**
\`\`\`scriban
{{ if variables.athlete.exists }}
The athlete is {{ variables.athlete.display_value }}.
{{ end }}
\`\`\`

### Rendering Config
- \`aspect_ratio\` → "16:9", "1:1"
- \`ai_provider\` → "OpenAI", "Stability"

**Usage:**
\`\`\`scriban
Aspect ratio: {{ rendering.aspect_ratio }}
Provider: {{ rendering.ai_provider }}
\`\`\`

---

## 📝 Example Template
\`\`\`scriban
Generate an image with aspect ratio {{ rendering.aspect_ratio }} using {{ rendering.ai_provider }}.

{{ if assets.athlete.exists }}
Use the athlete photo (type: {{ assets.athlete.type }}).
{{ end }}

{{ if variables.stats.exists }}
Display stats: {{ variables.stats.display_value }}
{{ end }}
\`\`\`

---

## ⚡ Best Practices
- Check existence before using assets or variables
- Use \`display_value\` for user‑friendly text
- Keep templates modular
- Always include rendering config at the start
`;

const PromptGuidePanel = () => (
    <PageContent>
        <ReactMarkdown>{guideMarkdown}</ReactMarkdown>
    </PageContent>
);

export default PromptGuidePanel;
